import React from 'react';
import DatePicker from 'components/pure/utils/form/DatePicker';
import RadioField from 'components/pure/utils/form/RadioField';
import InputField from 'components/pure/utils/form/InputField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import isNil from 'lodash/isNil';
import moment from 'moment';
import './RecurrenceEndSelector.styl';
import {
  RECURRENCE_COUNT_TYPE,
  RECURRENCE_END_DATE_TYPE,
  RECURRENCE_NO_END_TYPE,
} from 'records/EventSchedule';

const recurrenceProps = [RECURRENCE_COUNT_TYPE, RECURRENCE_END_DATE_TYPE];

export default class RecurrenceEndSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.refEls = {};
    this.state = {
      endType: recurrenceProps.find(prop => !isNil(props.schedule[prop])) || RECURRENCE_NO_END_TYPE,
    };
  }

  setEndType(endType, value) {
    const propSet = recurrenceProps.reduce(
      (schedule, prop) =>
        prop !== endType
          ? schedule.set(prop, null)
          : !isNil(value)
          ? schedule.set(prop, value)
          : schedule,
      this.props.schedule
    );

    const typeSet = propSet.set('recurrenceEndType', endType);

    this.props.onChange(typeSet);
    const input = this.refEls[endType];
    input && input.focus();
    this.setState({endType});
  }

  render() {
    const {schedule, showErrors, errors} = this.props;
    const {endType} = this.state;
    return (
      <div className="recurrence-end-selector">
        <div className="choice">
          <RadioField
            label="After"
            checked={endType === RECURRENCE_COUNT_TYPE}
            onClick={() => this.setEndType(RECURRENCE_COUNT_TYPE)}
          />
          <FieldContainer labelType="div" error={showErrors ? errors.recurrenceCount : null}>
            <InputField
              value={schedule.recurrenceCount || ''}
              type="number"
              size={4}
              min={1}
              inputRef={ref => (this.refEls.recurrenceCount = ref)}
              onChange={value => this.setEndType(RECURRENCE_COUNT_TYPE, value)}
            />
            <label>occurrences</label>
          </FieldContainer>
        </div>
        <div className="choice">
          <FieldContainer labelType="div" error={showErrors ? errors.recurrenceEndDate : null}>
            <RadioField
              label="On"
              checked={endType === RECURRENCE_END_DATE_TYPE}
              onClick={() => this.setEndType(RECURRENCE_END_DATE_TYPE)}
            />
            <DatePicker
              value={schedule.recurrenceEndDate}
              minDate={moment()}
              hintText=" / / "
              onChange={value => this.setEndType(RECURRENCE_END_DATE_TYPE, value)}
            />
          </FieldContainer>
        </div>
        <div className="choice">
          <RadioField
            label="Never"
            checked={endType === RECURRENCE_NO_END_TYPE}
            onClick={() => this.setEndType(RECURRENCE_NO_END_TYPE)}
          />
        </div>
      </div>
    );
  }
}
